import { takeLatest, put, call } from 'redux-saga/effects';
import { getArrayApiErrors } from 'utils/get-array-api-errors';
import { getHeaderFeaturesAPI } from 'features/header/api';
import { headerActions } from 'features/header/redux/header.action';
import { setPartnerHeaderFeaturesToLocalStorage } from 'utils/local-storage';
import { AxiosResponse } from 'axios';

function* getHeaderFeatures(): Generator<any, void, AxiosResponse> {
  try {
    const response = yield call(getHeaderFeaturesAPI);
    yield put(headerActions.getPartnerHeaderFeaturesSuccess(response.data));
    setPartnerHeaderFeaturesToLocalStorage(response.data);
  } catch (error) {
    yield put(
      headerActions.getPartnerHeaderFeaturesFailure(getArrayApiErrors(error))
    );
  }
}

function* headerSaga() {
  yield takeLatest(
    headerActions.getPartnerHeaderFeaturesRequest,
    getHeaderFeatures
  );
}

export default headerSaga;
